import React from 'react'
import Pagination from './Pagination'
import CardReview from './CardReview'
import { getReviews } from '../utils/client'
import useTranslation from '../hooks/UseTranslation'

const Reviews = (props) => {
  const { t } = useTranslation()
  const [reviews, setReviews] = React.useState(props.reviews)

  React.useEffect(() => {
    setReviews(props.reviews)
  }, [props.reviews])

  const [pageShowing, setPageShowing] = React.useState(0)
  const [isFullyFetched, setIsFullyFetched] = React.useState(false)
  const [isFetching, setIsFetching] = React.useState(false)

  const pageSize = 5
  let nPages = 0
  if (reviews) {
    const quotient = Math.floor(reviews.length / pageSize)
    const remainder = reviews.length % pageSize
    nPages = quotient + (remainder > 0 ? 1 : 0)
  }
  const start = pageShowing * pageSize
  const end = Math.min((pageShowing + 1) * pageSize, reviews.length)

  if (
    typeof window !== 'undefined' &&
    reviews.length - end < pageSize &&
    !isFullyFetched &&
    !isFetching
  ) {
    setIsFetching(true)
    const params = {
      skip: reviews.length,
      limit: pageSize * 2,
      revieweeId: props.user.id
    }
    getReviews(params).then((newlyFetched) => {
      if (newlyFetched.length == 0) setIsFullyFetched(true)
      else {
        reviews.push(...newlyFetched)
        setReviews(reviews)
      }
      setIsFetching(false)
    })
  }

  return (
    <div className='text-block'>
      <h4 className='mb-3 text-first-letter'>
        {t('reviews_what_people_say_about', props.user?.name_display)}
      </h4>
      {reviews.slice(start, end).map((review) => (
        <CardReview key={review.id} data={review} />
      ))}
      {nPages > 0 && (
        <Pagination
          n={nPages}
          selected={pageShowing}
          onPageChange={(p) => setPageShowing(p)}
        />
      )}
    </div>
  )
}

export default Reviews
